import { request } from "@/interface/helper";

const str = "gamemanage";

export const gamemanage = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/game/manage/list" }),
    add: data => request({ data, method: "post", url: "/game/manage/add" }),
    detail: data => request({ data, method: "post", url: "/game/manage/detail" }),
    edit: data => request({ data, method: "post", url: "/game/manage/modify" })
  }
};
